import keycloakAxios from '@/services/axios';
import {updateEventInRedux} from '@/redux-store/slices/events';
import {store} from '@/redux-store/store';
import {emitEventChangeEvent} from './change-observable';

export const leaveEvent = async (eventId: string) => {
  const response = await keycloakAxios.get(`event/${eventId}/leave`);

  if (response.status >= 300) {
    throw new Error(
      `Error leaving the event: Invalid status code: ${response.status}`
    );
  }

  const updatedResponseData = {
    ...response.data,
    price: response.data.price > 0 ? response.data.price / 100 : 0
  };

  emitEventChangeEvent({
    type: 'change',
    data: updatedResponseData
  });

  store.dispatch(updateEventInRedux({event: updatedResponseData}));

  return updatedResponseData;
};
